import { sendWebsocketMessage } from '../../../../../App';

/**
 * Instead of displaying the accountId, the user can display a nickname. This
 * message modifies the current nickname
 */

export function modifyNickname(accountId, nickname) {
  const msg = {
    accountId,
    nickname,
    messageType: 'accountNickname',
  }; 
  sendWebsocketMessage(msg);
}
